module.exports = __webpack_public_path__ + "static/media/eye-icon.66500ac9.svg";